/**
 * Persistencia de sucursal activa — Portal Cliente Menuee
 *
 * localStorage scoped por slug del local (mismo dominio, varios locales).
 * No confundir con sessionStorage de pedidos.
 */

export const STORAGE_SUCURSAL_ID_PREFIX = "menuee_sucursal_id";

/**
 * @param {string} slug
 * @returns {string|null}
 */
function clavePorSlug(slug) {
  const key = String(slug || "")
    .trim()
    .toLowerCase();
  if (!key) {
    return null;
  }
  return `${STORAGE_SUCURSAL_ID_PREFIX}:${key}`;
}

/**
 * @param {string} slug
 * @returns {string|null}
 */
export function leerSucursalIdPersistida(slug) {
  const clave = clavePorSlug(slug);
  if (!clave) {
    return null;
  }
  try {
    const id = localStorage.getItem(clave);
    return id ? String(id) : null;
  } catch {
    return null;
  }
}

/**
 * @param {string} slug
 * @param {string} sucursalId
 */
export function guardarSucursalIdPersistida(slug, sucursalId) {
  const clave = clavePorSlug(slug);
  if (!clave || !sucursalId) {
    return;
  }
  try {
    localStorage.setItem(clave, String(sucursalId));
  } catch {
    // localStorage no disponible
  }
}
